import { useRef, useState } from "react";

const useAddonReload = () => {
  const [reloadData, setReloadData] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const pendingActionReloadRef = useRef(false);

  const handleReload = ({ keepActionLoading = false } = {}) => {
    pendingActionReloadRef.current = keepActionLoading;
    setReloadData((prev) => !prev);
    return keepActionLoading;
  };

  return {
    reloadData,
    actionLoading,
    setActionLoading,
    pendingActionReloadRef,
    handleReload,
  };
};

export default useAddonReload;
